import React from 'react';
import {
  Button,
  Card,
  Divider,
  Header,
  Icon,
  List,
  Message,
  Tab,
} from 'semantic-ui-react';

export const PaneDocuments = (props) => {
  const {
    baseUrl,
    billOfSale,
    registrationCerts,
    signedAch,
  } = props;

  return (
    <Tab.Pane>
      <Card.Group itemsPerRow={2}>
        <Card>
           <Icon
            size="big"
            style={{ padding: '1.5em 0 3em 0' }}
            fitted
            name={billOfSale ? 'file' : 'question'}
            color={billOfSale ? 'green' : 'red'}
          />
          <Card.Content
            header="Bill of Sale"
            meta={billOfSale ? 'The Bill of Sale for this contract' : 'Missing'}
          />
          {
            billOfSale
              ? (
                  <Card.Content extra>
                    <Button
                      icon="download"
                      color="blue"
                      basic
                      size="tiny"
                      download={`${billOfSale.filename}`}
                      href={`/${baseUrl}/api/images/bill-of-sale/${billOfSale.filename}`}
                    />
                  </Card.Content>
                )
              : null
          }
        </Card>
        <Card>
           <Icon
            size="big"
            style={{ padding: '1.5em 0 3em 0' }}
            fitted
            name={signedAch ? 'file' : 'question'}
            color={signedAch ? 'green' : 'red'}
          />
          <Card.Content
            header="PAF (Payment Authorization Form)"
            meta={signedAch ? 'The PAF (Payment Authorization Form) for this contract' : 'Missing'}
          />
          {
            signedAch
              ? (
                  <Card.Content extra>
                    <Button
                      icon="download"
                      color="blue"
                      basic
                      size="tiny"
                      download={`${signedAch.filename}`}
                      href={`/${baseUrl}/api/images/signed-ach-authorization/${signedAch.filename}`}
                    />
                  </Card.Content>
                )
              : null
          }
        </Card>
      </Card.Group>
      {
        registrationCerts.map((sys, i) => (
          <div key={i}>
            <Divider hidden />
            <Header
              as="h3"
              dividing
              content={`Registration Certificate${sys.documents.length > 1 ? 's' : ''} for ${sys.name}`}
              subheader="The Registration Certificate document for this system"
            />
            <List divided size="large">
            {
              sys.documents.length
                ? (
                    sys.documents.map((doc, ii) => (
                      <List.Item key={ii}>
                        <Icon name="file" color="blue" size="large" />
                        <List.Content>
                          <List.Header content={`Registration Certificate ${ii + 1}`} />
                          <List.Description>
                            <Button
                              basic
                              icon="download"
                              size="mini"
                              color="blue"
                              download={doc.filename}
                              style={{ marginTop: '10px' }}
                              href={`/${baseUrl}/api/images/registration-certificate/${doc.filename}`}
                            />
                          </List.Description>
                        </List.Content>
                      </List.Item>
                    ))
                  )
                : (
                    <Message
                      header="Not Found"
                      icon="question"
                      warning
                      size="small"
                      content="We couldn't locate the registration certificate for this system"
                    />
                  )
            }
            </List>
          </div>
        ))
      }
    </Tab.Pane>
  );
}